import { BridgeActionEnum } from "@/types/webview";
import { postWebviewMessage } from "./postWebviewMessage";

export const getContactsStatus = (): void => {
  postWebviewMessage({
    action: BridgeActionEnum.GetContactsStatus,
  });
};
